import * as React from 'react'

const SvgRepeatIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.75 3.75H3.144L5.38 1.506 4.5.625.75 4.375l3.75 3.75.881-.881L3.144 5H15.75v4.375H17V5c0-.69-.56-1.25-1.25-1.25zm-2.131 9.006L15.856 15H3.25v-4.375H2V15c0 .69.56 1.25 1.25 1.25h12.606l-2.237 2.244.881.881 3.75-3.75-3.75-3.75-.881.881z"
      fill="#163250"
    />
  </svg>
)

export default SvgRepeatIcon
